import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Text, TextField, makeStyles } from '@knockrentals/knock-shared-web';
import OffsetSelect from './OffsetSelect';
import TimingLabel from './TimingLabel';
import { DAYS_TO_DELAY_LABEL_TEXT } from './constants';

const useStyles = makeStyles({
  input: {
    verticalAlign: 'baseline',
    width: '80px',
    '& label.MuiInputLabel-formControl': {
      left: '5px',
      position: 'absolute',
    },
  },
  daysToDelayText: { paddingRight: '5px' },
});

const DaysToDelay = ({
  actionTrigger,
  campaignTriggerOffsetModifier,
  clearErrorMessage,
  daysToDelay,
  handleDaysToDelayOnChange,
  hasError,
  isFormMode,
  isDaysToDelayDisabled,
  isTriggerOffsetSelectable,
  triggerLabelTiming,
  updateCampaignTriggerOffsetModifier,
}) => {
  const classes = useStyles();

  const timingLabelText = DAYS_TO_DELAY_LABEL_TEXT[triggerLabelTiming];

  return (
    <div
      className={classnames(isDaysToDelayDisabled && 'disable-days-to-delay')}
    >
      {isFormMode ? (
        <TextField
          className={classes.input}
          component="span"
          error={hasError}
          inputProps={{ style: { textAlign: 'center' } }}
          label="Number"
          margin="none"
          onChange={handleDaysToDelayOnChange}
          onFocus={clearErrorMessage}
          size="small"
          placeholder="#"
          value={daysToDelay || ''}
          variant="filled"
        />
      ) : (
        <Text
          className={classes.daysToDelayText}
          component="span"
          variant="subtitle1"
        >
          {daysToDelay}
        </Text>
      )}

      {isTriggerOffsetSelectable && isFormMode ? (
        <OffsetSelect
          campaignTriggerOffsetModifier={campaignTriggerOffsetModifier}
          updateCampaignTriggerOffsetModifier={
            updateCampaignTriggerOffsetModifier
          }
        />
      ) : (
        <TimingLabel
          actionTrigger={actionTrigger}
          hasError={hasError}
          labelText={timingLabelText}
        />
      )}
    </div>
  );
};

DaysToDelay.propTypes = {
  actionTrigger: PropTypes.string,
  campaignTriggerOffsetModifier: PropTypes.number,
  clearErrorMessage: PropTypes.func,
  daysToDelay: PropTypes.number,
  handleDaysToDelayOnChange: PropTypes.func,
  hasError: PropTypes.bool,
  isFormMode: PropTypes.bool,
  isDaysToDelayDisabled: PropTypes.bool,
  isTriggerOffsetSelectable: PropTypes.bool,
  triggerLabelTiming: PropTypes.string,
  updateCampaignTriggerOffsetModifier: PropTypes.func,
};

export default DaysToDelay;
